// TEMPORARY: unregisters leftover service workers from the removed PWA
// support so returning users stop being controlled by a stale registration.

export async function cleanupLegacyServiceWorkers() {
  if (
    typeof window === "undefined" ||
    typeof navigator === "undefined" ||
    !("serviceWorker" in navigator)
  ) {
    return 0;
  }

  let legacyPlaintrScope;
  try {
    legacyPlaintrScope = new URL("/", window.location.origin).href;
  } catch {
    return 0;
  }

  function isLegacyPlaintrScope(registration) {
    return registration.scope === legacyPlaintrScope;
  }

  let registrations;
  try {
    registrations = await navigator.serviceWorker.getRegistrations();
  } catch {
    return 0;
  }

  if (!Array.isArray(registrations) || registrations.length === 0) {
    return 0;
  }

  const ownRegistrations = registrations.filter(isLegacyPlaintrScope);

  const results = await Promise.all(
    ownRegistrations.map((registration) =>
      registration
        .unregister()
        .catch(() => false),
    ),
  );

  return results.filter(Boolean).length;
}
